import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

export const TermsPage = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <Header />
            <main className="flex-grow pt-16">
                <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
                    
                    <div className="prose prose-blue max-w-none space-y-8">
                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">1. Acceptance of Terms</h2>
                            <p className="text-gray-600">
                                By accessing and using KeepItSorted, you accept and agree to be bound by these terms of service. If you do not agree to these terms, please do not use our service.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">2. Service Description</h2>
                            <p className="text-gray-600">
                                KeepItSorted is a subscription management tool that helps users track and manage their recurring subscriptions. We provide a platform for organizing subscription information but do not directly manage or modify any of your actual subscriptions with third-party services.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">3. User Responsibilities</h2>
                            <ul className="list-disc pl-6 text-gray-600 space-y-2">
                                <li>Maintain accurate and up-to-date subscription information</li>
                                <li>Keep account credentials secure</li>
                                <li>Use the service in compliance with applicable laws</li>
                                <li>Not attempt to misuse or exploit the service</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="text-2xl font-semibold text-gray-900">4. Data Accuracy</h2>
                            <p className="text-gray-600">
                                While we strive to help you manage your subscriptions effectively, you are responsible for verifying all information and ensuring its accuracy. 
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}; 